export default __webpack_public_path__ + "static/media/signup_image.8187ef09.svg";